import axiosIns from '@/libs/axios'

export default {
  namespaced: true,
  state: {
    employeePositions: [],
    employeePositionsCount: 0,
    employeePosition: {},
    employeePositionSave: {
      message: null,
      status: null,
      id: null,
    },
  },
  getters: {
    getEmployeePositions(state) {
      return state.employeePositions
    },
    getEmployeePositionsCount(state) {
      return state.employeePositionsCount
    },
    getEmployeePosition(state) {
      return state.employeePosition
    },
    getEmployeePositionSaveStatus(state) {
      return state.employeePositionSave
    },
  },
  mutations: {
    EMPLOYEE_POSITIONS_LIST(state, data) {
      state.employeePositions = data
    },
    EMPLOYEE_POSITION_VIEW(state, data) {
      state.employeePosition = data
    },
    EMPLOYEE_POSITIONS_COUNT(state, data) {
      state.employeePositionsCount = data
    },
    EMPLOYEE_POSITION_SAVE(state, data) {
      state.employeePositionSave = data
    },
  },
  actions: {
    employeePositionsList({ commit }, params) {
      const data = JSON.stringify(params)
      axiosIns
        .post('/hr/employee_position', data)
        .then(response => {
          commit('EMPLOYEE_POSITIONS_LIST', response.data.data)
          commit('EMPLOYEE_POSITIONS_COUNT', response.data.count)
        })
        .catch(error => console.error(error))
    },
    employeePositionView({ commit }, id) {
      const data = JSON.stringify({
        where: {
          'employee_position.id': id,
        },
        array: false,
      })
      axiosIns
        .post('/hr/employee_position', data)
        .then(response => {
          commit('EMPLOYEE_POSITION_VIEW', response.data.data)
        })
        .catch(error => console.error(error))
    },
    employeePositionSave({ commit }, postData) {
      const data = JSON.stringify(postData)
      axiosIns
        .post('/hr/employee_position/saveData', data)
        .then(response => {
          commit('EMPLOYEE_POSITION_SAVE', response.data)
        })
        .catch(error => console.error(error))
    },
  },
}
